// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mk-1";
export var messageSideRight = "_mk-2";
export var subscribeToBackInStockBubbleContainer = "_mk-0";